<template>
    <div class="gx-rb">
        <gx-loading :show="loading" />
<!--        <h1 class="gx-main__title">报销管理</h1>-->

        <!-- 筛选区 -->
        <div class="gx-rb__head">

              <div class="gx-pb__filter custom-form-wrap">
                 <div class="gx-rb__filter-row">
                <el-form inline size="mini">
                    <el-form-item >
                        <el-select v-model="searchParams.platform_type" placeholder="请选择平台" clearable style="width:160px" filterable>
                            <el-option v-for="item in platformList" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-select v-model="searchParams.group_ids" multiple placeholder="全部分组" clearable style="width:160px" filterable>
                            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-select v-model="searchParams.mer_shop_id" multiple placeholder="全部店铺" clearable style="width:160px" filterable>
                            <el-option v-for="item in searchShopOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-select v-model="searchParams.type" multiple placeholder="全部类型" clearable style="width:160px" filterable>
                            <el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-input v-model="searchParams.platform_product_id" placeholder="商品ID" clearable style="width:160px" filterable></el-input>
                    </el-form-item>
            </el-form>
                </div>
<!-- 
            <div class="gx-rb__filter-row">
                <select v-model="searchParams.platform_type" class="gx-rb__select" @change="handlePlatformChange">
                    <option value="">请选择平台</option>
                    <option v-for="(name, val) in platformList" :key="val" :value="val">{{ name }}</option>
                </select>
                <multi-select v-model="searchParams.group_ids" :options="groupList" placeholder="全部分组" />
                <multi-select v-model="searchParams.mer_shop_id" :options="searchShopOptions" placeholder="全部店铺" />
                <multi-select v-model="searchParams.type" :options="typeOptions" placeholder="全部类型" />
                <input v-model="searchParams.platform_product_id" class="gx-rb__input" placeholder="商品ID"
                     @keyup.enter="getList(1)" />
            </div> -->
          <div class="gx-rb__filter-row">
                <!-- <span class="gx-rb__flabel">费用日期</span>
                <input v-model="dateStart" type="date" class="gx-rb__input" @change="syncDate" />
                <span class="gx-rb__dash">至</span>
                <input v-model="dateEnd" type="date" class="gx-rb__input" @change="syncDate" />
                <span class="gx-rb__flabel">费用金额</span>
                <input v-model.number="searchParams.reimbursement_money_start" type="number"
                    class="gx-rb__input gx-rb__input--sm" placeholder="0" />
                <span class="gx-rb__dash">-</span>
                <input v-model.number="searchParams.reimbursement_money_end" type="number"
                    class="gx-rb__input gx-rb__input--sm" placeholder="10000" /> -->
                <el-form inline size="mini">
                   <el-form-item label="费用时间">
                        <el-date-picker
                            v-model="searchParams.reimbursement_at"
                            type="daterange"
                            range-separator="-"
                            size="mini"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="datePickerOptions"
                            @change="getList(1)"
                            style="width:230px;">
                        </el-date-picker>
                    </el-form-item>
                     <el-form-item label="费用金额">
                        <div style="display: flex;align-items: center;gap: 6px;">
                            <el-input v-model.number="searchParams.reimbursement_money_start" type="number" placeholder="0" style="width: 100px;" />
                            -
                            <el-input v-model.number="searchParams.reimbursement_money_end" type="number" placeholder="0" style="width: 100px;" />
                        </div>
                    </el-form-item>
                </el-form>
                <div class="gx-rb__spacer"></div>
                <button class="gx-rb__btn gx-rb__btn--sm gx-rb__btn--primary" @click="getList(1)">查询</button>
                <button class="gx-rb__btn gx-rb__btn--sm" @click="resetSearch">重置</button>
            </div>

            </div>
        </div>

        <!-- 工具栏 -->
        <div class="gx-rb__toolbar">
            <button class="gx-rb__btn gx-rb__btn--add" @click="openForm(null)">
                <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                    <path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
                </svg>
                新增报销
            </button>
            <button class="gx-rb__btn gx-rb__btn--danger" :disabled="!selectedRows.length" @click="batchDelete">批量删除报销<span v-if="selectedRows.length">({{selectedRows.length}})</span></button>
            <span class="gx-rb__sum">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1.5" y="1.5" width="10" height="10" rx="2" stroke="#D4A946" stroke-width="1.2"></rect><path d="M4 6.5h5M4 9h3" stroke="#D4A946" stroke-width="1.2" stroke-linecap="round"></path><path d="M4 4h3" stroke="#D4A946" stroke-width="1.2" stroke-linecap="round"></path></svg>
              <span style="color: rgb(74, 74, 106);">合计总费用：</span>
              <span class="gx-rb__sum-money">¥{{ sumTotalMoney }}</span>
              <span style="color: rgb(106, 106, 138);">元</span>
            </span>
        </div>
        <div class="gx-rb__table-page">
          <!-- 表格 -->
          <div class="gx-rb__table">
              <table>
                  <thead>
                      <tr>
                          <th style="width: 36px">
                              <span class="gx-rb__check" :class="{ 'gx-rb__check--on': allChecked }" @click="toggleAll">
                                  <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                      <path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round"
                                          stroke-linejoin="round" />
                                  </svg>
                              </span>
                          </th>
                          <th style="width: 60px">序号</th>
                          <th v-for="h in ['费用类型', '平台', '店铺', '商品ID', '费用日期', '费用凭证', '费用金额', '费用备注', '创建时间', '操作']"
                              :key="h">{{ h }}</th>
                      </tr>
                  </thead>
                  <tbody>
                      <template v-for="(r, i) in list">
                          <tr :key="r.id" :class="{ 'gx-rb__row--parent': hasChildren(r) }">
                              <td>
                                  <span class="gx-rb__check" :class="{ 'gx-rb__check--on': selectedRows.includes(r.id) }"
                                      @click="toggleOne(r.id)">
                                      <svg v-if="selectedRows.includes(r.id)" width="8" height="8" viewBox="0 0 8 8"
                                          fill="none">
                                          <path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5"
                                              stroke-linecap="round" stroke-linejoin="round" />
                                      </svg>
                                  </span>
                              </td>
                              <td class="gx-rb__mono gx-rb__dim">
                                  <button v-if="hasChildren(r)" class="gx-rb__expand" type="button"
                                      @click.stop="toggleChildren(r)">{{ isExpanded(r) ? '▾' : '▸' }}</button>
                                  {{ (pageData.page - 1) * pageData.limit + i + 1 }}
                              </td>

                              <td><span class="gx-rb__tag" :style="tagStyle(String(r.type))">{{ typeName(r.type) }}</span>
                              </td>
                              <td><span class="gx-rb__tag" :class="`gx-rb__tag--${r.platform_type}`">{{ platformName(r.platform_type) }}</span>
                              </td>
                              <td>
                                  {{ shopName(r.mer_shop_id) === '未知店铺' ? '' : shopName(r.mer_shop_id) }}<span
                                      v-if="hasChildren(r)" class="gx-rb__parent-mark">合并费用</span>
                              </td>
                              <td class="gx-rb__mono">{{ r.platform_product_id }}</td>
                              <td class="gx-rb__mono gx-rb__dim">{{ r.reimbursement_at }}</td>
                              <td>
<!--                                  <span v-if="getImageUrls(r.pay_record).length" class="gx-rb__receipt"
                                      @click="openImgPreview(getImageUrls(r.pay_record), 0)">
                                      <img :src="getImageUrls(r.pay_record)[0]" alt="费用凭证" />
                                  </span>-->
                                <div class="gx-rb__imgs" v-if="getImageUrls(r.pay_record).length" >
                                  <!-- <span style="font-size: 14px;">🖼️</span>
                                  <span class="gx-rb__imgs-link" @click="openImgPreview(getImageUrls(r.pay_record), 0)">{{ getImageUrls(r.pay_record)[0] }}</span> -->
                                  <img :src="getImageUrls(r.pay_record)[0]" alt="费用凭证"  @click="openImgPreview(getImageUrls(r.pay_record), 0)" style="width: 50px;height: 50px;"/>
                                </div>
                              </td>
                              <td class="gx-rb__mono gx-rb__gold">¥{{ r.reimbursement_money }}</td>
                              <td class="gx-rb__msg">{{ r.reimbursement_msg || '--' }}</td>
                              <td class="gx-rb__mono gx-rb__dim">{{ r.created_at }}</td>
                              <td>
                                  <div class="gx-rb__ops" v-if="!isChildRow(r)">
                                      <button class="gx-rb__op gx-rb__op--view" @click="openView(r)">查看</button>
                                      <button class="gx-rb__op gx-rb__op--edit" @click="openForm(r)">修改</button>
                                      <button class="gx-rb__op gx-rb__op--del" @click="delOne(r)">删除</button>
                                  </div>
                              </td>
                          </tr>
                          <tr v-for="child in (isExpanded(r) ? r.children || [] : [])" :key="`${r.id}-${child.id}`"
                              class="gx-rb__row--child">
                              <td></td>
                              <td class="gx-rb__dim">↳</td>
                              <td><span class="gx-rb__tag" :style="tagStyle(String(child.type || r.type))">{{
                                  typeName(child.type || r.type) }}</span></td>
                              <td><span class="gx-rb__tag" :class="`gx-rb__tag--${child.platform_type}`">{{ platformName(child.platform_type ||  r.platform_type) }}</span></td>
                              <td>{{ shopName(child.mer_shop_id) }}</td>
                              <td class="gx-rb__mono">{{ child.platform_product_id || r.platform_product_id }}</td>
                              <td class="gx-rb__mono gx-rb__dim">{{ child.reimbursement_at || r.reimbursement_at }}</td>
                              <td>
                                <div class="gx-rb__imgs" v-if="getImageUrls(child.pay_record).length">
                                  <!-- <span style="font-size: 14px;">🖼️</span>
                                  <span class="gx-rb__imgs-link" @click="openImgPreview(getImageUrls(child.pay_record), 0)">{{ getImageUrls(child.pay_record)[0] }}</span> -->
                                  <img :src="getImageUrls(child.pay_record)[0]" alt="费用凭证"  @click="openImgPreview(getImageUrls(child.pay_record), 0)" style="width: 50px;height: 50px;"/>
                                </div>
                              </td>
                              <td class="gx-rb__mono gx-rb__gold">¥{{ child.reimbursement_money }}</td>
                              <td class="gx-rb__msg">{{ child.reimbursement_msg || '--' }}</td>
                              <td class="gx-rb__mono gx-rb__dim">{{ child.created_at || r.created_at }}</td>
                              <td></td>
                          </tr>
                      </template>
                      <tr v-if="!list.length">
                          <td :colspan="12" class="gx-rb__empty">暂无报销数据</td>
                      </tr>
                  </tbody>
              </table>
          </div>

          <!-- 分页 -->
          <!-- <div class="gx-rb__pager">
              <div class="gx-rb__pager-left">
                  <span class="gx-rb__pager-total">共 {{ pageData.total }} 条</span>
                  <page-size-select :value="pageData.limit" :options="[10, 20, 50, 100]" @change="onPageSizeChange" />
              </div>
              <div class="gx-rb__pager-btns">
                  <button class="gx-rb__page" :disabled="pageData.page <= 1"
                      @click="getList(pageData.page - 1)">‹</button>
                  <button v-for="n in pageNums" :key="n" class="gx-rb__page"
                      :class="{ 'gx-rb__page--on': n === pageData.page }" @click="getList(n)">{{ n }}</button>
                  <button class="gx-rb__page" :disabled="pageData.page >= totalPages"
                      @click="getList(pageData.page + 1)">›</button>
              </div>
          </div> -->

        <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
            <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getList(pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
        </div>
      </div>

        <!-- 新增/编辑/查看弹窗 -->
        <div v-if="dialogVisible" class="gx-modal" @click.self="dialogVisible = false">
            <div class="gx-modal-box">
                <div class="gx-modal-head">
                    <span class="gx-modal-title">{{ dialogTitle }}</span>
                    <button class="gx-modal-close" @click="dialogVisible = false">✕</button>
                </div>
                <div class="gx-modal-body custom-el-wrapper">
                    <div class="gx-rb__field">
                        <label class="gx-rb__label"><span class="gx-rb__req">*</span>平台类型</label>
                      <el-select v-model="form.platform_type" placeholder="请选择平台" size="small" class="sel-full">
                        <el-option v-for="(name, val) in platformList" :key="val" :value="val" :label="name"></el-option>
                      </el-select>
                    </div>
                    <div class="gx-rb__field">
                        <label class="gx-rb__label">店铺名</label>
                        <multi-select v-if="dialogType !== 'view'" v-model="form.mer_shop_ids"
                            :options="formShopOptions" placeholder="请选择店铺" searchable select-all
                            @input="syncAllocations" />

                        <div v-else class="gx-rb__readonly">{{ formShopSummary }}</div>
                    </div>
                    <div class="gx-rb__field gx-rb__allocation">
                        <label class="gx-rb__label">费用分摊</label>
                        <div class="gx-rb__allocation-types">
                            <button type="button" :disabled="dialogType === 'view' || !form.platform_type"
                                :class="{ 'gx-rb__allocation-type--on': form.allocation_type === 1 }"
                                @click="setAllocationType(1)">平摊</button>
                            <button type="button" :disabled="dialogType === 'view' || !form.platform_type"
                                :class="{ 'gx-rb__allocation-type--on': form.allocation_type === 2 }"
                                @click="setAllocationType(2)">自填</button>
                            <button v-if="form.allocation_type && dialogType !== 'view'" type="button"
                                class="gx-rb__allocation-cancel" @click="clearAllocation">取消分摊</button>
                        </div>
                        <div v-if="form.allocation_type === 2" class="gx-rb__allocation-list">
                            <div class="gx-rb__allocation-list-title">按店铺填写分摊金额</div>
                            <div v-for="shop in allocationShopList" :key="shop.mer_shop_id"
                                class="gx-rb__allocation-item">
                                <span>{{ shop.shop_name }}</span><input
                                    v-model.number="form.shop_allocations[shop.mer_shop_id]" type="number" min="0"
                                    step="0.01" :disabled="dialogType === 'view'" />
                            </div>
                        </div>
                        <!-- <span v-if="form.mer_shop_ids.length <= 1" class="gx-rb__allocation-tip">选择两个及以上店铺后可设置费用分摊</span> -->
                    </div>
                    <div class="gx-rb__field">
                        <label class="gx-rb__label">
                            <span class="gx-rb__req">*</span>费用类型
                            <span class="gx-rb__label-hint">— 直接输入选择可新建费用类型</span>
                        </label>
                        <div v-if="dialogType !== 'view'" class="gx-rb__type-picker w420">
                            <button type="button" class="gx-rb__type-trigger"
                                :class="{ 'gx-rb__type-trigger--open': typeDropdownOpen }"
                                @click="toggleTypeDropdown">
                                <span>{{ form.type_name || '请选择或输入费用类型' }}</span>
<!--                                <span class="gx-rb__type-caret" :class="{ 'gx-rb__type-caret&#45;&#45;open': typeDropdownOpen }">▾</span>-->
                              <span class="gx-rb__type-caret">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" :style="`flex-shrink: 0;transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);transform: rotate(${typeDropdownOpen?180:0}deg)`">
                                  <path d="M1 2.5l3 3 3-3" stroke="#4A4A6A" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                              </span>
                            </button>
                            <div v-if="typeDropdownOpen" class="gx-rb__type-panel" @click.stop>
                                <div class="gx-rb__type-panel-head">
                                    <input v-model.trim="typeKeyword" class="gx-rb__type-search"
                                        placeholder="直接输入选择可新建费用类型" @keyup.enter="createTypeFromKeyword" />
                                    <button type="button" class="gx-rb__type-new"
                                        :disabled="!typeKeyword.trim()" @click="createTypeFromKeyword">新建</button>
                                </div>
                                <button v-for="(name, val) in filteredTypeList" :key="val" type="button"
                                    class="gx-rb__type-option" :class="{ 'gx-rb__type-option--on': form.type === String(val) }"
                                    @click="selectType(val, name)">{{ name }}</button>
                                <div v-if="!Object.keys(filteredTypeList).length" class="gx-rb__type-empty">暂无费用类型</div>
                            </div>
                        </div>
                        <div v-else class="gx-rb__readonly">{{ form.type_name || '--' }}</div>
                    </div>
                    <div class="gx-rb__field">
                        <label class="gx-rb__label">商品ID</label>
                        <input v-model="form.platform_product_id" class="gx-rb__input gx-rb__input--full"
                            :disabled="dialogType === 'view'" placeholder="请输入商品ID" />
                    </div>
                    <div class="gx-rb__field">
                        <label class="gx-rb__label"><span class="gx-rb__req">*</span>费用日期</label>
                        <input v-model="form.reimbursement_at" type="date" class="gx-rb__input gx-rb__input--full"
                            :disabled="dialogType === 'view'" />
                    </div>
                    <div class="gx-rb__field">
                        <label class="gx-rb__label"><span class="gx-rb__req">*</span>费用金额</label>
                        <div v-if="dialogType !== 'view'" class="gx-rb__amount-row">
                            <div class="gx-rb__amount-stepper">
                                <span class="gx-rb__amount-currency">¥</span>
                                <button type="button" class="gx-rb__amount-btn" @click="adjustAmount(-0.1)">−</button>
                                <input :value="formatAmount(form.reimbursement_money)" type="number" step="0.0001" min="0"
                                    class="gx-rb__amount-input" placeholder="0.1000" @input="onAmountInput"
                                    @blur="normalizeAmount" />
                                <button type="button" class="gx-rb__amount-btn" @click="adjustAmount(0.1)">+</button>
                            </div>
                            <span class="gx-rb__amount-hint">精确到4位小数</span>
                        </div>
                        <div v-else class="gx-rb__amount-readonly">¥{{ formatAmount(form.reimbursement_money) }}</div>
                    </div>

                    <div class="gx-rb__field">
                        <label class="gx-rb__label">费用凭证</label>
                        <div class="gx-rb__upload" v-if="dialogType !== 'view'">
                            <span class="gx-rb__upload-icon" aria-hidden="true">📁</span>
                            <span class="gx-rb__upload-title">点击上传费用凭证</span>
                            <span class="gx-rb__upload-tip">支持 jpg/png/pdf/doc/docx/xls/xlsx/txt，单文件最大5MB，最多上传10个</span>
                            <label class="gx-rb__upload-btn">
                                {{ uploading ? '上传中...' : '选择文件' }}
                                <input type="file" multiple :accept="acceptTypes" style="display:none"
                                    @change="onFilesChange" :disabled="uploading" />
                            </label>
                        </div>
                        <div v-if="fileList.length" class="gx-rb__file-list">
                            <div v-for="(f, i) in fileList" :key="f.url" class="gx-rb__file-item">
                                <img v-if="isImage(f.url)" :src="f.url" class="gx-rb__file-img" alt=""
                                    @click="openImgPreview([f.url], 0)" />
                                <span v-else class="gx-rb__file-icon">📄</span>
                                <span class="gx-rb__file-name">{{ f.object_name || f.name }}</span>
                                <button v-if="dialogType !== 'view'" class="gx-rb__file-del"
                                    @click="removeFile(i)">✕</button>
                            </div>
                        </div>
                    </div>
                    <div class="gx-rb__field">
                        <label class="gx-rb__label">费用备注</label>
                        <textarea v-model="form.reimbursement_msg" class="gx-rb__textarea" rows="3"
                            :disabled="dialogType === 'view'" placeholder="请输入备注"></textarea>
                    </div>
                </div>
                <div class="gx-modal-foot">
                    <button class="gx-modal-foot-btn" @click="dialogVisible = false">取消</button>
                    <button v-if="dialogType !== 'view'" class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="saving"
                        @click="save">
                        {{ saving ? '保存中...' : '确认保存' }}
                    </button>
                </div>
            </div>
        </div>

        <!-- 图片预览 -->
        <div v-if="previewUrl" class="gx-rb__preview" @click="previewUrl = ''">
            <img :src="previewUrl" alt="" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import MultiSelect from '../cloudOptimize/MultiSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import Pagination from '../../components/newUi/Pagination.vue'
import { uploadDirectOss } from '../../assets/js/utils/ossDirectUpload'

const ACCEPT_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/plain']

export default {
    name: 'NewReimbursePage',
    components: { GxLoading, PageSizeSelect, MultiSelect, Pagination },
    mixins: [gxLoading],
    data() {
        return {
            searchParams: { platform_type: '', group_ids: [], mer_shop_id: [], type: [], platform_product_id: '', reimbursement_money_start: 0, reimbursement_money_end: 10000 },
            dateStart: '',
            dateEnd: '',
            list: [],
            selectedRows: [],
            expandedRowIds: [],
            pageData: { limit: 10, page: 1, total: 0 },
            typeList: {},
            platformList: {},
            shopList: [],
            groupList: [],
            sumTotalMoney: 0,
            dialogVisible: false,
            dialogType: 'add',
            dialogTitle: '',
            form: {},
            typeDropdownOpen: false,
            typeKeyword: '',
            fileList: [],
            uploading: false,
            saving: false,
            previewUrl: '',
            acceptTypes: ACCEPT_TYPES.join(','),
            isCancelAllocate: false,//取消分摊
        }
    },
    computed: {
        totalPages() {
            return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
        },
        pageNums() {
            const total = this.totalPages
            const nums = []
            const half = 2
            let start = Math.max(1, this.pageData.page - half)
            let end = Math.min(total, start + half * 2)
            start = Math.max(1, end - half * 2)
            for (let i = start; i <= end; i++) nums.push(i)
            return nums.length ? nums : [1]
        },
        allChecked() {
            return this.list.length > 0 && this.selectedRows.length === this.list.length
        },
        typeOptions() {
            return Object.keys(this.typeList).map((k) => ({ id: k, name: this.typeList[k] }))
        },
        filteredTypeList() {
            return this.typeList
        },
        searchShopOptions() {
            if (!this.searchParams.platform_type) return this.shopList.map((s) => ({ id: s.mer_shop_id, name: s.shop_name }))
            return this.shopList.filter((s) => String(s.shop_type) === String(this.searchParams.platform_type)).map((s) => ({ id: s.mer_shop_id, name: s.shop_name }))
        },
        formFilteredShops() {
            if (!this.form.platform_type) return []
            return this.shopList.filter((s) => String(s.shop_type) === String(this.form.platform_type))
        },
        formShopOptions() {
            return this.formFilteredShops.map((s) => ({ id: String(s.mer_shop_id), name: s.shop_name }))
        },
        formShopSummary() {
            const names = (this.form.mer_shop_ids || []).map((id) => this.shopName(id))
            return names.length ? names.join('、') : '未选择店铺'
        },
        allocationShopList() {
            const ids = (this.form.mer_shop_ids || []).map(String)
            if (ids.length) return this.formFilteredShops.filter((s) => ids.includes(String(s.mer_shop_id)))
            return this.dialogType === 'add' ? this.formFilteredShops : []
        },
    },
    created() {
        this.getList(1)
        this.loadShops()
        this.loadGroupList()
    },
    methods: {
        ...mapActions({
            opGetUserReimbursement: 'ucenter/opGetUserReimbursement',
            opGetMerchantAllShopList: 'ucenter/opGetMerchantAllShopList',
            opSaveUserReimbursement: 'ucenter/opSaveUserReimbursement',
            opUpdateUserReimbursement: 'ucenter/opUpdateUserReimbursement',
            opDeleteUserReimbursement: 'ucenter/opDeleteUserReimbursement',
            getShopBoardGroupList: 'shop_board/getShopBoardGroupList'
        }),
        loadShops() {
            this.opGetMerchantAllShopList({
                data: {},
                success: (res) => {
                    if (res.code === 200) this.shopList = res.data || []
                }
            })
        },
        loadGroupList() {
            this.getShopBoardGroupList({
                data: {},
                success: (res) => {
                    if (res.code === 200) this.groupList = res.data || []
                }
            })
        },
        syncDate() {
            if (this.dateStart && this.dateEnd) {
                this.searchParams.reimbursement_at = [this.dateStart, this.dateEnd]
            } else {
                delete this.searchParams.reimbursement_at
            }
        },
        getList(page) {
            this.pageData.page = page
            const param = { page_size: this.pageData.limit, page: this.pageData.page }
            Object.keys(this.searchParams).forEach((k) => {
                if (this.searchParams[k] !== '' && this.searchParams[k] !== undefined && this.searchParams[k] !== null && !(Array.isArray(this.searchParams[k]) && !this.searchParams[k].length)) {
                    param[k] = this.searchParams[k]
                }
            })
            this.loadingStart()
            this.opGetUserReimbursement({
                data: param,
                success: (res) => {
                    this.loadingEnd()
                    if (res.code === 200) {
                        this.list = res.data.list || []
                        this.pageData.total = res.data.total || 0
                        this.typeList = res.data.Reimbursement_Type_List || {}
                        this.platformList = res.data.platform_type || {}
                        this.sumTotalMoney = res.data.sumTotalMoney || 0
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        resetSearch() {
            this.searchParams = { platform_type: '', group_ids: [], mer_shop_id: [], type: [], platform_product_id: '', reimbursement_money_start: 0, reimbursement_money_end: 10000 }
            this.dateStart = ''
            this.dateEnd = ''
            this.getList(1)
        },
        onPageSizeChange(size) {
            this.pageData.limit = size
            this.getList(1)
        },
        handlePlatformChange() {
            this.searchParams.mer_shop_id = []
            this.expandedRowIds = []
        },
        hasChildren(row) {
            return Array.isArray(row.children) && row.children.length > 0
        },
        isExpanded(row) {
            return this.expandedRowIds.includes(String(row.id))
        },
        toggleChildren(row) {
            const id = String(row.id)
            const index = this.expandedRowIds.indexOf(id)
            if (index === -1) this.expandedRowIds.push(id)
            else this.expandedRowIds.splice(index, 1)
        },
        shopName(id) {
            const s = this.shopList.find((x) => String(x.mer_shop_id) === String(id))
            return s ? s.shop_name : ''
        },
        typeName(type) {
            const name = this.typeList[type] || this.typeList[String(type)]
            if (name) return name
            const raw = type !== undefined && type !== null ? String(type).trim() : ''
            return raw && Number.isNaN(Number(raw)) ? raw : '未知费用类型'
        },
        platformName(type) {
            return this.platformList[type] || this.platformList[String(type)] || '未知平台'
        },
        tagStyle(type) {
            const map = { 1: 'blue', 2: 'green', 3: 'yellow', 7: 'green' }
            const colors = {
                blue: { background: '#E6F4FF', border: '1px solid #91CAFF', color: '#1677FF' },
                green: { background: '#F6FFED', border: '1px solid #B7EB8F', color: '#52C41A' },
                yellow: { background: '#FFF7E6', border: '1px solid #FFD591', color: '#FA8C16' }
            }
            return colors[map[type]] || colors.green
        },
        isChildRow(row) { return String(row.record_mode) === '3' || Number(row.parent_id || 0) > 0 },
        syncAllocations() {
            const shops = this.allocationShopList.map(item => String(item.mer_shop_id));
            if (this.form.allocation_type === 1) {
                const n = shops.length;
                const base = n ? Math.floor((Number(this.form.reimbursement_money || 0) / n) * 100) / 100 : 0;
                this.form.shop_allocations = {};
                shops.forEach((s, i) => this.$set(this.form.shop_allocations, s, Number(i === 0 ? Number(this.form.reimbursement_money || 0) - base * (n - 1) : base).toFixed(2)))
            } else if (this.form.allocation_type === 2) {
                this.form.shop_allocations = shops.reduce((result, id) => { result[id] = this.form.shop_allocations[id] ?? ''; return result }, {})
            } else {
                this.form.shop_allocations = {}
            }
        },
        clearAllocation() {
            this.form.allocation_type = 0;
            this.form.shop_allocations = {}
            this.isCancelAllocate = false
        },

        toggleOne(id) {
            const idx = this.selectedRows.indexOf(id)
            if (idx > -1) this.selectedRows.splice(idx, 1)
            else this.selectedRows.push(id)
        },
        toggleAll() {
            if (this.allChecked) this.selectedRows = []
            else this.selectedRows = this.list.map((r) => r.id)
        },
        openForm(row) {
            this.dialogType = row && row.id ? 'update' : 'add'
            this.dialogTitle = row && row.id ? '修改报销' : '新增报销'
            this.resetForm()
            if (row && row.id) {
                Object.assign(this.form, row)
                this.form.platform_type = String(row.platform_type || '')
                this.form.type = String(row.type || '')
                this.form.type_name = row.type_name || this.typeName(row.type)
                this.form.mer_shop_id = String(row.mer_shop_id || '')
                this.form.mer_shop_ids = row.children?.length ? row.children.map(x => String(x.mer_shop_id)) : (row.mer_shop_id ? [String(row.mer_shop_id)] : []);
                this.form.allocation_type = Number(row.allocation_type || 0);
                this.form.shop_allocations = Object.fromEntries((row.children || []).map(x => [x.mer_shop_id, Number(x.reimbursement_money)])); const recordArr = Array.isArray(row.pay_record) ? row.pay_record : []
                this.fileList = recordArr.filter((item) => item && item.url).map((item) => ({ name: item.object_name, url: item.url, object_name: item.object_name }))
            }
            this.dialogVisible = true
        },
        openView(row) {
            this.dialogType = 'view'
            this.dialogTitle = '查看费用'
            this.resetForm()
            Object.assign(this.form, row)
            this.form.platform_type = String(row.platform_type || '')
            this.form.type = String(row.type || '')
            this.form.type_name = row.type_name || this.typeName(row.type)
            this.form.mer_shop_id = String(row.mer_shop_id || '')
            this.form.mer_shop_ids = this.rowShopIds(row)
            this.form.allocation_type = Number(row.allocation_type || 0)
            this.form.shop_allocations = Object.fromEntries((row.children || []).map((x) => [String(x.mer_shop_id), Number(x.reimbursement_money)]))
            const recordArr = Array.isArray(row.pay_record) ? row.pay_record : []
            this.fileList = recordArr.filter((item) => item && item.url).map((item) => ({ name: item.object_name, url: item.url, object_name: item.object_name }))
            this.dialogVisible = true
        },
        resetForm() {
            this.form = { id: '', type: '', platform_type: '', mer_shop_id: '', mer_shop_ids: [], allocation_type: 0, shop_allocations: {}, reimbursement_at: '', platform_product_id: '', reimbursement_money: 0.1, reimbursement_msg: '', pay_record: [] }
            this.typeDropdownOpen = false
            this.typeKeyword = ''
            this.fileList = []
        },
        onPlatformChange() {
            this.form.mer_shop_id = ''
            this.form.mer_shop_ids = [];
            this.form.allocation_type = 0;
            this.form.shop_allocations = {};
        },
        rowShopIds(row) {
            const ids = row.mer_shop_ids || (row.children || []).map((child) => child.mer_shop_id)
            return (ids && ids.length ? ids : [row.mer_shop_id]).filter((id) => id !== '' && id !== null && id !== undefined).map(String);
        },
        // syncAllocations() {
        //     const ids = this.allocationShopList.map((shop) => String(shop.mer_shop_id))
        //     if (this.form.allocation_type === 1) {
        //         const total = Number(this.form.reimbursement_money || 0)
        //         const base = Math.floor(total / ids.length * 100) / 100
        //         this.form.shop_allocations = {}
        //         ids.forEach((id, i) => this.$set(this.form.shop_allocations, id, i === 0 ? total - base * (ids.length - 1) : base))
        //     } else if (this.form.allocation_type === 2) {
        //         const old = this.form.shop_allocations || {}
        //         this.form.shop_allocations = ids.reduce((result, id) => { result[id] = old[id] == null ? '' : old[id]; return result }, {})
        //     } else {
        //         this.form.shop_allocations = {}
        //     }
        // },
        setAllocationType(type) {
            if (!this.form.platform_type) {
                this.$message.warning('请先选择平台')
                return
            }
            this.form.allocation_type = type
            this.syncAllocations()
        },
        toggleTypeDropdown() {
            if (this.dialogType === 'view') return
            this.typeDropdownOpen = !this.typeDropdownOpen
            if (this.typeDropdownOpen) this.typeKeyword = ''
        },
        selectType(value, name) {
            this.form.type = String(value)
            this.form.type_name = name
            this.typeKeyword = ''
            this.typeDropdownOpen = false
        },
        createTypeFromKeyword() {
            const name = String(this.typeKeyword || '').trim()
            if (!name) return
            this.form.type = ''
            this.form.type_name = name
            this.typeKeyword = ''
            this.typeDropdownOpen = false
        },
        formatAmount(value) {
            const amount = Number(value)
            return Number.isFinite(amount) ? amount.toFixed(4) : ''
        },
        onAmountInput(event) {
            const raw = event.target.value
            if (raw === '') {
                this.form.reimbursement_money = null
                this.syncAllocations()
                return
            }
            const amount = Number(raw)
            if (!Number.isFinite(amount)) return
            this.form.reimbursement_money = Number(amount.toFixed(4))
            this.syncAllocations()
        },
        normalizeAmount(event) {
            const amount = Number(this.form.reimbursement_money)
            if (!Number.isFinite(amount)) {
                this.form.reimbursement_money = null
                event.target.value = ''
                return
            }
            this.form.reimbursement_money = Math.max(0.1, Number(amount.toFixed(4)))
            event.target.value = this.formatAmount(this.form.reimbursement_money)
            this.syncAllocations()
        },
        adjustAmount(step) {
            const current = Number(this.form.reimbursement_money)
            const amount = Number.isFinite(current) ? current : 0
            this.form.reimbursement_money = Math.max(0.1, Number((amount + step).toFixed(4)))
            this.syncAllocations()
        },
        save() {
            if (!this.form.platform_type) {
                this.$message.warning('请选择平台')
                return
            }
            const shopIds = this.form.mer_shop_ids || []
            const allocationIds = this.allocationShopList.map((shop) => String(shop.mer_shop_id))
            if (!shopIds.length && !this.form.allocation_type) {
                this.$message.warning('请选择店铺或费用分摊方式')
                return
            }
            if (this.form.mer_shop_ids.length > 1 && !this.form.allocation_type) {
                this.$message.error('请选择费用分摊类型');
                return
            }
            if (!String(this.form.type_name || '').trim()) {
                this.$message.warning('请输入费用类型')
                return
            }
            const knownType = Object.keys(this.typeList).find((key) => this.typeList[key] === this.form.type_name)
            this.form.type = knownType === undefined ? this.form.type_name : String(knownType)
            if (!this.form.reimbursement_at) {
                this.$message.warning('请选择费用日期')
                return
            }
            if (!this.form.reimbursement_money || this.form.reimbursement_money <= 0) {
                this.$message.warning('请输入正确的费用金额')
                return
            }
            if (shopIds.length > 1 && !this.form.allocation_type) {
                this.$message.warning('请选择费用分摊方式')
                return
            }
            const submitIds = this.form.allocation_type ? allocationIds : shopIds
            if (!submitIds.length) {
                this.$message.warning('当前平台没有可分摊店铺')
                return
            }
            if (this.form.allocation_type === 2) {
                const allocated = submitIds.reduce((sum, id) => sum + Number(this.form.shop_allocations[id] || 0), 0)
                if (Math.abs(allocated - Number(this.form.reimbursement_money)) > 0.001) {
                    this.$message.warning('自填分摊金额必须等于费用金额')
                    return
                }
            }
            const submitData = { ...this.form, mer_shop_ids: submitIds, mer_shop_id: submitIds[0] }
            this.saving = true
            const done = (res, msg) => {
                this.saving = false
                if (res.code === 200) {
                    this.$message.success(msg)
                    this.dialogVisible = false
                    this.getList(this.pageData.page)
                } else {
                    this.$message.error(res.message)
                }
            }
            if (this.dialogType === 'update') {
                this.opUpdateUserReimbursement({
                    data: submitData,
                    success: (res) => done(res, '修改成功')
                })
            } else {
                this.opSaveUserReimbursement({
                    data: submitData,
                    success: (res) => done(res, '新增成功')
                })
            }
        },
        delOne(row) {
            this.$confirm(`确定要删除该条报销数据吗？`, '提示', { type: 'warning' }).then(() => {
                this.opDeleteUserReimbursement({
                    data: { del_ids: [row.id] },
                    success: (res) => {
                        if (res.code === 200) {
                            this.$message.success('删除成功')
                            this.getList(this.pageData.page)
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            }).catch(() => { })
        },
        batchDelete() {
            if (!this.selectedRows.length) {
                this.$message.warning('请选择要删除的数据')
                return
            }
            this.$confirm(`确定要删除 ${this.selectedRows.length} 条报销数据吗？`, '提示', { type: 'warning' }).then(() => {
                this.opDeleteUserReimbursement({
                    data: { del_ids: this.selectedRows },
                    success: (res) => {
                        if (res.code === 200) {
                            this.$message.success('删除成功')
                            this.selectedRows = []
                            this.getList(this.pageData.page)
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            }).catch(() => { })
        },
        beforeUpload(file) {
            if (!ACCEPT_TYPES.includes(file.type)) {
                this.$message.error('仅支持 jpg、png、pdf、word、excel、txt 格式')
                return false
            }
            if (file.size / 1024 / 1024 >= 5) {
                this.$message.error('文件大小不能超过 5MB！')
                return false
            }
            return true
        },
        async onFilesChange(e) {
            const files = Array.from(e.target.files || [])
            e.target.value = ''
            const valid = files.filter((f) => this.beforeUpload(f))
            if (!valid.length) return
            this.uploading = true
            try {
                await Promise.all(valid.map(async (file) => {
                    try {
                        const data = await uploadDirectOss(file, { purpose: 'attachment' })
                        if (!data.url) throw new Error('上传接口未返回文件地址')
                        this.form.pay_record = this.form.pay_record || []
                        const url = data.url
                        if (!this.form.pay_record.some((item) => item.url === url)) {
                            const info = { url, object_name: data.object_name || file.name, suffix: data.suffix, storage_path: data.storage_path }
                            this.form.pay_record.push(info)
                            this.fileList.push(info)
                        }
                    } catch (error) {
                        this.$message.error(error.message || '文件上传失败')
                    }
                }))
            } finally {
                this.uploading = false
            }
        },
        removeFile(i) {
            this.form.pay_record.splice(i, 1)
            this.fileList.splice(i, 1)
        },
        isImage(url) {
            if (!url) return false
            const ext = url.split('.').pop().toLowerCase().split('?')[0]
            return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
        },
        getImageUrls(list) {
            const arr = Array.isArray(list) ? list : []
            return arr.filter((item) => this.isImage(item && item.url)).map((item) => item.url)
        },
        openImgPreview(imgList, startIndex) {
            this.previewUrl = imgList[startIndex]
        }
    }
}
</script>

<style scoped>
.w420{
  width: 420px;
}
.gx-rb__head {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 11px 14px;
  margin-bottom: 14px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}

.gx-rb__filter-row {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
}

.gx-rb__filter-row+.gx-rb__filter-row {
    margin-top: 10px;
}

.gx-rb__flabel {
    font-size: 12px;
    color: #4A4A6A;
    white-space: nowrap;
}

.gx-rb__select {
    height: 28px;
    padding: 0 8px;
    border-radius: 4px;
    border: 1px solid #e0e0ec;
    background: #FFFFFF;
    font-size: 12px;
    color: #1A1A2E;
    outline: none;
    min-width: 120px;
}

.gx-rb__select--full {
    width: 100%;
    min-width: 0;
}

.gx-rb__input {
    width: 130px;
    height: 28px;
    padding: 0 10px;
    border-radius: 7px;
    border: 1px solid #e0e0ec;
    font-size: 12px;
    color: #1A1A2E;
    outline: none;
    box-sizing: border-box;
}

.gx-rb__input--sm {
    width: 90px;
}

.gx-rb__input--full, .sel-full {
    width: 100%;
}

.gx-rb__dash {
    color: #6A6A8A;
    font-size: 12px;
}

.gx-rb__spacer {
    flex: 1;
}

.gx-rb__btn {
    height: 30px;
    padding: 0 14px;
    border-radius: 6px;
    cursor: pointer;
    background: #FFFFFF;
    border: 1px solid #e0e0ec;
    font-size: 13px;
    color: #4A4A6A;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: all .16s;
}
.gx-rb__btn--sm{
  height: 26px;
  border-radius: 5px;
  font-size: 11px;
  padding: 0 9px;
}

.gx-rb__btn:disabled {
    opacity: .5;
    cursor: not-allowed;
}

.gx-rb__btn--primary {
    background: linear-gradient(135deg, #D4A946, #E8C778);
    border: none;
    font-weight: 600;
    color: rgb(244, 246, 248);
}

.gx-rb__btn--add {
    background: linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
    border: none;
    font-weight: 600;
    color: rgb(255, 255, 255);
    box-shadow: rgba(255, 77, 79, 0.25) 0px 0px 10px;
}

.gx-rb__btn--danger {
  background: rgba(248, 113, 113, 0.07);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(248, 113, 113);
}

.gx-rb__btn--danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gx-rb__btn--danger:hover {
    background: #FFF5F5;
}

.gx-rb__toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    flex-wrap: wrap;
}

.gx-rb__sum {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 6px;
  background: rgba(212, 169, 70, 0.08);
  border: 1px solid rgba(212, 169, 70, 0.3);
  margin-left: auto;
  font-size: 12px;
}
.gx-rb__sum-money{
  font-size: 14px;
  font-weight: 700;
  color: rgb(212, 169, 70);
}
.gx-rb__table-page{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 4px;
}
.gx-rb__table {
    border-radius: 8px 8px 0 0;
   /* overflow: hidden;
    border: 1px solid #E1E5EE;*/
    background: #FFFFFF;
}

.gx-rb__table table {
    width: 100%;
    border-collapse: collapse;
    white-space: nowrap;
}

.gx-rb__table th {
    padding: 10px 12px;
    text-align: left;
    background: rgb(245, 240, 232);
    font-size: 11px;
    font-weight: 500;
    color: rgb(74, 74, 106);
    border-bottom: 1px solid #E1E5EE;
}

.gx-rb__table td {
  padding: 12px 13px;
    font-size: 12px;
    color: #1A1A2E;
    border-top: 1px solid rgba(212, 169, 70, .07);
}

.gx-rb__check {
    width: 14px;
    height: 14px;
    border-radius: 4px;
    border: 1.5px solid rgb(224, 224, 236);
    background: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  box-sizing: border-box;
}

.gx-rb__check--on {
  background: rgb(200, 68, 60);
  border: 1.5px solid rgb(200, 68, 60);
}

.gx-rb__tag {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    display: inline-block;
  font-weight: 500;
}

.gx-rb__tag--1 {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-rb__tag--7 {
  background: rgb(246, 255, 237);
  border: 1px solid rgb(183, 235, 143);
  color: rgb(82, 196, 26);
}

.gx-rb__mono {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
}
.gx-rb__imgs{
  display: flex; align-items: center; gap: 4px;
}
.gx-rb__imgs-link{
  font-size: 11px;
  color: rgb(22, 119, 255);
  cursor: pointer;
  text-decoration: underline;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}


.gx-rb__gold {
  font-size: 13px;
  font-weight: 700;
  color: rgb(200, 68, 60)!important;
}

.gx-rb__dim {
    color: #6A6A8A !important;
}

.gx-rb__msg {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.gx-rb__receipt {
    display: inline-block;
    width: 60px;
    height: 60px;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #E1E5EE;
    cursor: zoom-in;
}

.gx-rb__receipt img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.gx-rb__ops {
    display: flex;
    gap: 6px;
}

.gx-rb__op {
    height: 24px;
    padding: 0 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 11px;
    border: 1px solid;
    transition: all .16s;
    white-space: nowrap;
}

.gx-rb__op--view {
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: rgb(22, 119, 255);
}
.gx-rb__op--view:hover{
  background: rgb(22, 119, 255);
  color: #fff;
}

.gx-rb__op--edit{
  background: rgba(212, 169, 70, 0.1);
  border: 1px solid rgba(212, 169, 70, 0.3);
  color: rgb(212, 169, 70);
}

.gx-rb__op--edit:hover{
  background: rgb(212, 169, 70);
  color: #fff;
}

.gx-rb__op--del {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}

.gx-rb__op--del:hover {
    background: rgb(200, 68, 60);
    color: #fff;
}

.gx-rb__empty {
    text-align: center;
    padding: 52px 0 !important;
    color: #6A6A8A;
}

.gx-rb__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: rgb(245, 240, 232);
  border-radius: 0 0 8px 8px;
}

.gx-rb__pager-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.gx-rb__pager-total {
    font-size: 12px;
    color: #6A6A8A;
}

.gx-rb__pager-btns {
    display: flex;
    gap: 5px;
}

.gx-rb__page {
   min-width: 28px;
   height: 26px;
    padding: 0 8px;
    border-radius: 4px;
    border: 1px solid #E1E5EE;
    background: #FFFFFF;
    cursor: pointer;
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: #4A4A6A;
}

.gx-rb__page:disabled {
    opacity: .5;
    cursor: not-allowed;
}

.gx-rb__page--on {
  border: 1px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  color: rgb(200, 68, 60);
}

.gx-rb__field :deep(.el-input__inner::placeholder),
.gx-rb__field :deep(.el-select__caret){
  color: #4A4A6A;
}
.gx-rb__label {
  display: block;
  font-size: 11px;
  color: rgb(74, 74, 106);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.gx-rb__req {
  font-size: 13px;
  color:rgb(200, 68, 60);
}

.gx-rb__textarea {
    width: 100%;
    padding: 10px 12px;
    border-radius: 7px;
    border: 1px solid rgba(212, 169, 70, .2);
    font-size: 13px;
    color: #1A1A2E;
    outline: none;
    box-sizing: border-box;
    resize: vertical;
    font-family: 'Noto Sans SC', sans-serif;
}



.gx-rb__type-suggest {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
}

.gx-rb__type-chip {
    padding: 3px 10px;
    border-radius: 5px;
    border: 1px solid #E1E5EE;
    font-size: 11px;
    color: #4A4A6A;
    cursor: pointer;
    transition: all .13s;
}

.gx-rb__type-chip:hover {
    border-color: rgba(212, 169, 70, .5);
}

.gx-rb__type-chip--on {
    background: rgba(212, 169, 70, .1);
    border-color: rgba(212, 169, 70, .5);
    color: #D4A946;
}

.gx-rb__upload {
    display: flex;
    align-items: center;
    gap: 10px;
}

.gx-rb__upload-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 12px;
    border-radius: 7px;
    cursor: pointer;
    background: linear-gradient(135deg, #D4A946, #E8C778);
    border: none;
    font-size: 12px;
    font-weight: 600;
    color: #F4F6F8;
}

.gx-rb__upload-tip {
    font-size: 11px;
    color: #6A6A8A;
}

.gx-rb__file-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.gx-rb__file-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    border-radius: 7px;
    background: #FFFFFF;
    border: 1px solid #E1E5EE;
    font-size: 12px;
    color: #1A1A2E;
}

.gx-rb__file-img {
    width: 34px;
    height: 34px;
    border-radius: 5px;
    object-fit: cover;
    cursor: pointer;
}

.gx-rb__file-icon {
    font-size: 16px;
}

.gx-rb__file-name {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gx-rb__file-del {
    border: none;
    background: none;
    cursor: pointer;
    color: #6A6A8A;
    font-size: 11px;
    padding: 0;
}

.gx-rb__preview {
    position: fixed;
    inset: 0;
    z-index: 800;
    background: rgba(0, 0, 0, .8);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: zoom-out;
}

.gx-rb__preview img {
    max-width: 80vw;
    max-height: 80vh;
    border-radius: 8px;
}

.gx-rb__multi-full {
    width: 100% !important;
}

.gx-rb__multi-full :deep(.gx-ms__btn) {
    min-width: 100%;
    font-size: 13px;
    min-height: 32px;
    padding: 5px 10px;
}

.gx-rb__multi-full :deep(.gx-ms__placeholder),
.gx-rb__multi-full :deep(.gx-ms__summary) {
    margin-right: auto;
}

.gx-rb__row--parent td {
    background: #f4f8ff;
    font-weight: 600;
}

.gx-rb__row--child td {
    background: #fbfcff;
    color: #6a6a8a;
    font-size: 12px;
}

.gx-rb__expand {
    width: 20px;
    margin-right: 4px;
    padding: 0;
    border: 0;
    color: #1677ff;
    background: transparent;
    cursor: pointer;
    font-size: 15px;
}

.gx-rb__allocation-tip {
    color: #9099aa;
    font-size: 12px;
}

.gx-rb__field .gx-ms {
    display: block;
    width: 100%;
}

.gx-rb__field /deep/ .gx-ms__btn {
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
}

.gx-rb__readonly {
    min-height: 32px;
    box-sizing: border-box;
    padding: 7px 10px;
    border: 1px solid #e1e5ee;
    border-radius: 7px;
    color: #4a4a6a;
    background: #f7f8fa;
    font-size: 13px;
    line-height: 18px;
    word-break: break-all;
}

.gx-rb__parent-mark {
    margin-left: 6px;
    padding: 2px 5px;
    border-radius: 4px;
    color: #1677ff;
    background: #e6f4ff;
    font-size: 10px;
}

.gx-rb__allocation-types {
    display: flex;
    align-items: center;
    gap: 16px;
}

.gx-rb__allocation-types button {
    height: 30px;
    padding: 0 14px;
    border: 1px solid #d9dfe9;
    border-radius: 6px;
    color: #4a4a6a;
    background: #fff;
    cursor: pointer;
    font-size: 12px;
}

.gx-rb__allocation-types .gx-rb__allocation-type--on {
    border-color: #d4a946;
    color: #8d6714;
    background: #fff8e8;
    font-weight: 600;
}

.gx-rb__allocation-types button:disabled {
    cursor: default;
}

.gx-rb__allocation-types .gx-rb__allocation-cancel {
    margin-left: auto;
    border-color: transparent;
    color: #9099aa;
}

.gx-rb__allocation-list {
    max-height: 180px;
    margin-top: 8px;
    padding: 8px;
    border: 1px solid #e1e5ee;
    border-radius: 8px;
    background: #fafbfc;
    overflow-y: auto;
}

.gx-rb__allocation-list-title {
    margin-bottom: 6px;
    color: #6a6a8a;
    font-size: 12px;
}

.gx-rb__allocation-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 34px;
    padding: 4px 0;
    border-top: 1px solid #edf0f5;
    font-size: 13px;
    color: var(--gx-black);
}

.gx-rb__allocation-list-title+.gx-rb__allocation-item {
    border-top: 0;
}

.gx-rb__allocation-item span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gx-rb__allocation-item input {
    width: 120px;
    padding: 5px 7px;
    border: 1px solid #d9dfe9;
    border-radius: 5px;
}

/* 报销弹窗与财务工作台参考页保持一致，仅作用于本页弹窗。 */
.gx-rb .gx-modal {
    padding: 16px;
    background: rgba(0, 0, 0, .42);
    backdrop-filter: blur(4px);
}

.gx-rb .gx-modal-box {
  width: 100%;
  max-width: 520px;
  border-radius: 10px;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(224, 224, 236);
  box-shadow: rgba(0, 0, 0, 0.18) 0px 12px 48px;
  display: flex;
  flex-direction: column;
  max-height: 92vh;
  overflow: hidden;
}

.gx-rb .gx-modal-head {
    flex: 0 0 auto;
    padding: 13px 18px;
    border-bottom: 1px solid rgb(224, 224, 236);
    background: rgb(245, 240, 232);
}

.gx-rb .gx-modal-title {
    font-size: 15px;
    line-height: 22.5px;
}

.gx-rb .gx-modal-close {
    width: 26px;
    height: 26px;
    padding: 0;
    border: 2px solid rgb(224, 224, 236);
    border-radius: 5px;
    background: #fff;
    color: #1a1a2e;
    font-size: 16px;
    line-height: 24px;
}

.gx-rb .gx-modal-body {
  overflow-y: auto;
  flex: 1 1 0%;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.gx-rb .gx-modal-foot {
    display: flex;
    flex: 0 0 auto;
    justify-content: flex-end;
    gap: 8px;
    margin: 0;
    padding: 12px 18px;
    border-top: 1px solid rgb(224, 224, 236);
    background: rgb(245, 240, 232);
}

.gx-rb .gx-modal-foot-btn {
    height: 32px;
    padding: 0 13px;
    border-radius: 6px;
    border: 1px solid rgb(224, 224, 236);
    background: #fff;
    color: rgb(74, 74, 106);
    font-size: 13px;
}

.gx-rb .gx-modal-foot-btn--yellow {
    border-color: transparent;
    background: #d4a946;
    color: #f4f6f8;
}

.gx-rb .gx-modal .gx-rb__select--full,
.gx-rb .gx-modal .gx-rb__input--full {
    width: 100%;
    min-width: 0;
    height: 32px;
    box-sizing: border-box;
    padding: 0 12px;
    border: 1px solid rgb(224, 224, 236);
    border-radius: 5px;
    background: #fff;
    color: #1a1a2e;
    font-size: 13px;
}

.gx-rb .gx-modal .gx-rb__select--full {
    appearance: auto;
}

.gx-rb .gx-modal .gx-rb__input--full[type='date'],
.gx-rb .gx-modal .gx-rb__input--full[type='number'] {
    font-family: 'JetBrains Mono', monospace;
}

.gx-rb .gx-modal .gx-rb__select--full:disabled,
.gx-rb .gx-modal .gx-rb__input--full:disabled,
.gx-rb .gx-modal .gx-rb__textarea:disabled {
    background: rgb(245, 240, 232);
    color: #6a6a8a;
    opacity: 1;
}

.gx-rb .gx-modal .gx-rb__textarea {
    min-height: 57px;
    padding: 8px 12px;
    border: 1px solid rgb(224, 224, 236);
    border-radius: 5px;
    font-size: 13px;
    line-height: 19.5px;
}


.gx-rb .gx-modal .gx-rb__field /deep/ .gx-ms__btn {
    width: 100%;
    min-width: 0;
    min-height: 32px;
    height: 32px;
    box-sizing: border-box;
    align-items: center;
    padding: 0 12px;
    border: 1px solid rgb(224, 224, 236);
    border-radius: 5px;
    font-size: 13px;
}

.gx-rb .gx-modal .gx-rb__field /deep/ .gx-ms__summary,
.gx-rb .gx-modal .gx-rb__field /deep/ .gx-ms__placeholder {
    line-height: 34px;
}

.gx-rb .gx-modal .gx-rb__readonly {
    min-height: 36px;
    box-sizing: border-box;
    padding: 8px 12px;
    border: 1px solid rgb(224, 224, 236);
    border-radius: 5px;
    background: rgb(245, 240, 232);
    color: #6a6a8a;
    font-size: 13px;
    line-height: 18px;
}

.gx-rb .gx-modal .gx-rb__type-suggest {
    gap: 6px;
    margin-top: 8px;
}

.gx-rb .gx-modal .gx-rb__label-hint {
    margin-left: 4px;
    color: #6a6a8a;
    font-size: 11px;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
}

.gx-rb .gx-modal .gx-rb__type-picker {
    position: relative;
    width: 100%;
}

.gx-rb .gx-modal .gx-rb__type-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    gap: 8px;
    padding: 0 9px;
    border: 1px solid rgb(224, 224, 236);
    border-radius: 5px;
    background: #fff;
    color: #6a6a8a;
    cursor: pointer;
    font-size: 13px;
    text-align: left;
    transition: border-color .15s;
}

.gx-rb .gx-modal .gx-rb__type-trigger > span:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gx-rb .gx-modal .gx-rb__type-trigger--open {
    border-color: rgba(212, 169, 70, .65);
}

.gx-rb .gx-modal .gx-rb__type-caret {
    flex: 0 0 auto;
    color: #4a4a6a;
    font-size: 14px;
    line-height: 1;
    transform: translateY(-2px);
    transition: transform .15s;
}

.gx-rb .gx-modal .gx-rb__type-caret--open {
    transform: rotate(180deg) translateY(2px);
}

.gx-rb .gx-modal .gx-rb__type-panel {
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    z-index: 600;
    width: 100%;
    max-height: 220px;
    box-sizing: border-box;
    overflow-y: auto;
    border: 2px solid rgb(224, 224, 236);
    border-radius: 5px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .12);
}

.gx-rb .gx-modal .gx-rb__type-panel-head {
    display: flex;
    gap: 5px;
    padding: 7px 10px;
    border-bottom: 1px solid rgb(224, 224, 236);
    background: #fff;
}

.gx-rb .gx-modal .gx-rb__type-search {
    flex: 1 1 auto;
    min-width: 0;
    height: 26px;
    box-sizing: border-box;
    padding: 0 8px;
    border: 1px solid rgb(224, 224, 236);
    border-radius: 4px;
    outline: none;
    color: #1a1a2e;
    font-size: 12px;
}

.gx-rb .gx-modal .gx-rb__type-new {
    flex: 0 0 auto;
    height: 26px;
    padding: 0 8px;
    border: 0;
    border-radius: 4px;
    background: rgb(200, 68, 60);
    color: #fff;
    cursor: pointer;
    font-size: 12px;
}

.gx-rb .gx-modal .gx-rb__type-new:disabled {
    cursor: not-allowed;
    opacity: .45;
}

.gx-rb .gx-modal .gx-rb__type-option {
    display: block;
    width: 100%;
    min-height: 35px;
    padding: 8px 10px;
    border: 0;
    background: #fff;
    color: #1a1a2e;
    cursor: pointer;
    font-size: 13px;
    text-align: left;
    white-space: nowrap;
}

.gx-rb .gx-modal .gx-rb__type-option:hover,
.gx-rb .gx-modal .gx-rb__type-option--on {
    background: rgb(245, 240, 232);
}

.gx-rb .gx-modal .gx-rb__type-option--on {
    color: #8d6714;
    font-weight: 600;
}

.gx-rb .gx-modal .gx-rb__type-empty {
    padding: 18px 10px;
    color: #6a6a8a;
    font-size: 12px;
    text-align: center;
}

.gx-rb .gx-modal .gx-rb__type-chip {
    padding: 4px 10px;
    border-radius: 5px;
    border-color: rgb(224, 224, 236);
    background: #fff;
    font-size: 12px;
}

.gx-rb .gx-modal .gx-rb__allocation-types {
    gap: 8px;
}

.gx-rb .gx-modal .gx-rb__allocation-types button {
    height: 32px;
    padding: 0 14px;
    border-radius: 5px;
}

.gx-rb .gx-modal .gx-rb__allocation-list {
    margin-top: 10px;
    border-radius: 5px;
    background: #fff;
}

.gx-rb .gx-modal .gx-rb__allocation-item input {
    height: 32px;
    box-sizing: border-box;
    padding: 0 8px;
    border-radius: 5px;
    font-family: 'JetBrains Mono', monospace;
}

.gx-rb .gx-modal .gx-rb__amount-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.gx-rb .gx-modal .gx-rb__amount-stepper {
    display: flex;
    align-items: center;
    min-width: 0;
    overflow: hidden;
    border: 2px solid rgb(224, 224, 236);
    border-radius: 5px;
}

.gx-rb .gx-modal .gx-rb__amount-currency,
.gx-rb .gx-modal .gx-rb__amount-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    box-sizing: border-box;
    background: rgb(245, 240, 232);
}

.gx-rb .gx-modal .gx-rb__amount-currency {
    flex: 0 0 auto;
    padding: 0 10px;
    border-right: 1px solid rgb(224, 224, 236);
    color: #d4a946;
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
}

.gx-rb .gx-modal .gx-rb__amount-btn {
    flex: 0 0 32px;
    padding: 0;
    border: 0;
    color: #1a1a2e;
    cursor: pointer;
    font-size: 16px;
}

.gx-rb .gx-modal .gx-rb__amount-btn:first-of-type {
    border-right: 1px solid rgb(224, 224, 236);
}

.gx-rb .gx-modal .gx-rb__amount-btn:last-of-type {
    border-left: 1px solid rgb(224, 224, 236);
}

.gx-rb .gx-modal .gx-rb__amount-input {
    width: 100px;
    height: 36px;
    box-sizing: border-box;
    padding: 0;
    border: 0;
    outline: none;
    background: #fff;
    color: rgb(200, 68, 60);
    font-family: 'JetBrains Mono', monospace;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
}

.gx-rb .gx-modal .gx-rb__amount-input::-webkit-outer-spin-button,
.gx-rb .gx-modal .gx-rb__amount-input::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
}

.gx-rb .gx-modal .gx-rb__amount-input[type='number'] {
    appearance: textfield;
}

.gx-rb .gx-modal .gx-rb__amount-hint {
    flex: 0 0 auto;
    color: #6a6a8a;
    font-size: 11px;
}

.gx-rb .gx-modal .gx-rb__amount-readonly {
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    padding: 0 12px;
    border: 1px solid rgb(224, 224, 236);
    border-radius: 5px;
    background: rgb(245, 240, 232);
    color: rgb(200, 68, 60);
    font-family: 'JetBrains Mono', monospace;
    font-size: 14px;
    font-weight: 700;
    line-height: 36px;
}

.gx-rb .gx-modal .gx-rb__upload {
    min-height: 118px;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 18px;
    border: 1px dashed rgb(224, 224, 236);
    border-radius: 5px;
    background: #fff;
    text-align: center;
}

.gx-rb .gx-modal .gx-rb__upload-icon {
    font-size: 24px;
    line-height: 24px;
}

.gx-rb .gx-modal .gx-rb__upload-title {
    color: #4a4a6a;
    font-size: 13px;
}

.gx-rb .gx-modal .gx-rb__upload-tip {
    color: #6a6a8a;
    font-size: 11px;
    line-height: 16px;
}

.gx-rb .gx-modal .gx-rb__upload-btn {
    height: 28px;
    padding: 0 14px;
    border-radius: 5px;
    background: rgb(200, 68, 60);
    font-size: 12px;
}

.gx-rb .gx-modal .gx-rb__file-list {
    gap: 8px;
    margin-top: 10px;
}

.gx-rb .gx-modal .gx-rb__file-item {
    min-height: 32px;
    box-sizing: border-box;
    padding: 0 8px;
    border-radius: 5px;
    background: rgb(245, 240, 232);
}

.gx-rb .gx-modal .gx-rb__file-img {
    width: 20px;
    height: 20px;
    border-radius: 3px;
}

@media (min-width: 768px) {
    .gx-rb .gx-modal {
        padding: 24px;
    }

    .gx-rb .gx-modal-box {
        max-height: calc(100vh - 48px);
    }
}

@media (max-width: 480px) {
    .gx-rb .gx-modal .gx-rb__allocation-item input {
        width: 108px;
    }

    .gx-rb .gx-modal .gx-rb__upload {
        padding-right: 10px;
        padding-left: 10px;
    }
}
</style>
<style scoped>
.allocation-shop-list {
    display: flex;
    flex-direction: column;
    margin-top: 6px;
    padding: 4px 10px;
    border: 1px solid rgba(212, 169, 70, .18);
}

.allocation-shop-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #666666;
    padding: 4px 0;
}

.allocation-shop-item~.allocation-shop-item {
    border-top: 1px dashed rgba(212, 169, 70, .18);
}
</style>
